<template>
  <div>
    <header class="landing-page-header">
      <div class="header-inner" id="main-header">
        <div class="header left-align">
          <a href="/" title="landing-page">
            <div class="logo-img desktop-view">
              <svg><use xlink:href="#logo_img"></use></svg>
            </div>
          </a>
          <div class="mobile-view">
            <div class="logo-img">
              <a href="/" title="landing-page">
                <svg><use xlink:href="#mobile_logo"></use></svg>
              </a>
            </div>
          </div>
          <div class="user-profile mobile-view" v-if="!$route.params.clubName">
            <div class="name" v-if="userName">{{ userName }}</div>
            <div class="clubname" v-if="userClub && userClub.short_name">&nbsp;- {{ userClub.short_name }}</div>
          </div>
        </div>
        <div class="header right-align">
          <div id="mySidenav" class="sidenav">
            <div class="header-links-outer">
              <div class="header-link user-details-wrap">
                <h5 :class="[userClub ? 'user-club-name': 'user-full-name']" class="full-name">{{fullName}}</h5>
                <div class="user-details" :class="[clubImage?'club-info':'']" v-if="this.$data.globalData.user">
                  <div class="user-info fb-img" v-if="imageUrl">
                    <img v-bind:src="imageUrl" alt="facebook"/>
                  </div>
                  <div v-else>
                    <div class="user-info name" v-if="userName">{{userName.charAt(0).toUpperCase()}}</div>
                  </div>
                  <button class="club-join-img" v-if="this.$data.globalData && this.$data.globalData.user">
                    <img v-if="this.$data.globalData.user.user_club && this.$data.globalData.user.user_club.image_url"
                    v-bind:src="this.$data.globalData.user.user_club.image_url" alt="club"/>
                    <img v-else src="/static/images/club_default.png" alt="club"/>
                    <div class="club-logo-points"  v-if="this.$data.globalData && this.$data.globalData.user && this.$data.globalData.user.user_total_points">
                      {{this.$data.globalData.user.user_total_points}}
                    </div>
                  </button>
                </div>
              </div>
              <div class="header-link">
                <a href="/vinningar">Vinningar</a>
                <div class="logo-img forward-arrow">
                  <svg><use xlink:href="#yellow_arrow"></use></svg>
                </div>
              </div>
              <div class="header-link">
                <a href="/leikreglur/">Leikreglur</a>
                <div class="logo-img forward-arrow">
                  <svg><use xlink:href="#yellow_arrow"></use></svg>
                </div>
              </div>
              <div class="header-link">
                <a href="/golfvernd/">Golfvernd</a>
                <div class="logo-img forward-arrow">
                  <svg><use xlink:href="#yellow_arrow"></use></svg>
                </div>
              </div>
              <!-- <div class="header-link">
                <a href="../static/pdf/Golfreglur_Leikmannautgafa_2019.pdf" target="_blank"> Sækja Regluvarðar bókina </a>
                <div class="logo-img forward-arrow">
                  <svg><use xlink:href="#yellow_arrow"></use></svg>
                </div>
              </div> -->
              <div class="header-link" v-if="userName">
                <a href="/leader-board">Stigatafla</a>
                <div class="logo-img forward-arrow">
                  <svg><use xlink:href="#yellow_arrow"></use></svg>
                </div>
              </div>
              <div class="header-link" v-if="userName">
                <a href="/logout/">Útskráning</a>
                <div class="logo-img forward-arrow">
                  <svg><use xlink:href="#yellow_arrow"></use></svg>
                </div>
              </div>
            </div>
          </div>
          <p v-if="this.isLive" class="menu-text desktop-view">Valmynd</p>
          <div v-if="this.isLive" class="logo-img" onclick="openNav()">
            <svg><use xlink:href="#menu_icon"></use></svg>
          </div>
          <div class="close-menu" v-if="this.isLive">
            <a href="javascript:void(0)" class="closebtn" onclick="closeNav()">&times;</a>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
export default {
  name: 'HeaderPart',
  data () {
    return {
      isLive: false,
      userName: null,
      imageUrl: null,
      fullName: null,
      clubImage: null,
      // userTotalPoints: null,
      userClub: null
    }
  },
  created () {
    // if (this.$data.globalData.user && this.$data.globalData.user.user_total_points) {
    //   this.userTotalPoints = this.$data.globalData.user.user_total_points
    // }
    if (this.$data.globalData.webroute === 'live') {
      this.isLive = true
    }
    if (this.$data.globalData.user && this.$data.globalData.user.image_url) {
      this.imageUrl = this.$data.globalData.user.image_url
    } else if (this.$data.globalData.user && this.$data.globalData.user.name) {
      this.userName = this.$data.globalData.user.name
    }
    if (this.$data.globalData.user) {
      this.fullName = this.$data.globalData.user.name
      this.userClub = this.$data.globalData.user.user_club
    }
    if (this.$data.globalData.user && this.$data.globalData.user.user_club) {
      this.clubImage = this.$data.globalData.user.user_club.image_url
    }
  },
  watch: {
    '$data.globalData.user.user_club': {
      handler(newValue) {
        this.userClub = newValue
      },
      deep: true
    },
  },
  methods: {
    // showPopupVinnigar (name) {
    //   console.log('name', name)
    //   closeNav()
    //   this.$router.push({ path: name})
    // },
  }
}
</script>
<style lang="scss">
.user-info,.club-join-img,.user-points-added,.user-details {
	display: inline-block;
  vertical-align: middle;
  margin: 0 8px;
}
.user-details-wrap {
  display: flex !important;
}
.full-name {
	bottom: -4px;
  font-size: 20px;
	position: relative;
	display: inline-block;
  padding-right: 25px;
  color: #fff;
  flex: 0 0 80%;
}
.user-club-name {
	right: 0px;
}
.user-info {
	&.name {
		font-size: 22px;
    padding: 0;
    border: 1px solid transparent;
    background: #fcbe00;
    width: 65px;
    height: 65px;
    border-radius: 50%;
    text-align: center;
    line-height: 57px;
  }
  &.fb-img {
    width: 75px;
    height: 75px;
    position: relative;
    overflow: hidden;
    border-radius: 50%;
    border: 1px solid transparent;
    img {
      // border-radius: 50%;
      position: absolute;
      height: auto;
      width: auto;
      max-width: 100%;
      max-height: initial;
    }
  }
}
.user-details {
  margin: 0;
  // padding-left: 60px;
  display: flex;
}
.club-join-img {
  width: 65px;
  height: 65px;
  background: transparent;
  border: none;
}
.club-logo-points {
  font-size: 18px;
  color: #FFFFFF;
  width: 35px;
  height: 35px;
  text-align: center;
  border-radius: 50%;
  border: 1px solid #FCBD00;
  background: #FCBD00;
  padding: 4px;
  position: absolute;
  top: 45px;
  right: 10px;
  line-height: 29px;
}
.user-details {
  position: relative;
  color: #fff;
}
.club-info {
   &:after {
     right: 475px;
   }
}
.mobile-levelnames {
  display: table-cell;
  vertical-align: middle;
  .levels-name {
    display: table-cell;
    vertical-align: middle;
    padding-right: 1.5rem;
    &.regluvardar {
      svg {
        width: 53px;
        height: 53px;
      }
    }
    svg {
      width: 28px;
      height: 28px;
    }
  }
}
.mobile-view {
  .logo-img {
    display: table-cell;
    vertical-align: middle;
  }
}
@media (max-width: 767px) {
  .user-info.name {
    width: 45px;
    height: 45px;
    line-height: 42px;
  }
  .club-join-img {
    width: 56px;
    height: 55px;
  }
  .club-logo-points {
    top: 38px;
    width: 25px;
    height: 25px;
    font-size: 12px;
    line-height: 18px;
  }
  .full-name {
    flex: 0 0 50%;
  }
  .user-info.fb-img {
    width: 55px;
    height: 55px;
  }
}
</style>
